import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { mapPlantsForAnalysis } from '@/shared/data-mappers';
import type { AnalysisPlant } from '@/shared/data-types';

/**
 * 발전 분석용 발전소 목록 query 정의 SSOT — 발전량/수익 화면 스코프(전체/단일) + 좌표(일사량) + 인버터
 * 용량/출력. BE = app-legacy(v3) `GET /plants`(inverters·address 기본 포함). 스코프 셀렉터의 lean
 * `plantsWithDevicesQueryOptions` 와 같은 엔드포인트지만 rich projection(`mapPlantsForAnalysis`).
 */
export const PLANTS_FOR_ANALYSIS_QUERY_KEY = ['plants', 'for-analysis'] as const;

export const plantsForAnalysisQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<AnalysisPlant[]>({
    queryKey: PLANTS_FOR_ANALYSIS_QUERY_KEY,
    queryFn: async ({ signal }) =>
      mapPlantsForAnalysis(await api.plant.list(undefined, { signal })),
  });
